import * as angular from 'angular';
import * as jquery from 'jquery';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'GroupAnalyticsWrapperController',
            GroupAnalyticsWrapperController
        );

    function GroupAnalyticsWrapperController($compile, $scope) {
        var vm = this;

        vm.isTwoWindows = false;

        vm.addWindow = function () {
            if (!vm.isTwoWindows) {
                vm.isTwoWindows = true;
                angular
                    .element(document.getElementById('newWindow'))
                    .append(
                        $compile('<im-group-analytics></im-group-analytics>')(
                            $scope
                        )
                    );
            }
        };

        vm.removeWindow = function () {
            if (vm.isTwoWindows) {
                vm.isTwoWindows = false;
                jquery('#newWindow im-group-analytics').remove();
            }
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/group-analytics/group-analytics-container.controller.ts